import SHA256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';
export default {
  encode(source) {
    return Base64.stringify(SHA256(source));
  }
}